import ProfilesApi from '../api/profiles';

function sortAscending(a, b) {
  return b.score - a.score;
}
function getDefaultState() {
  return {
    profiles: [],
    selectedAudienceProfile: {},
  };
}
export default {
  namespaced: true,
  state: {
    profiles: [],
    selectedAudienceProfile: {},
  },
  getters: {
    videoProfiles(state) {
      return state.profiles;
    },
    personality(state) {
      if (state.profiles.length > 0) {
        const userProfile = state.profiles.find(p => p.audience === false);
        return userProfile.profile.profile.personality;
      }
      return [];
    },
    topPersonalityFeatures(state) {
      if (state.profiles.length > 0) {
        const userProfile = state.profiles.find(p => p.audience === false);
        if (userProfile.profile.profile.personality) {
          return userProfile.profile.profile.personality.sort(sortAscending).slice(0, 3);
        }
      }
      return [];
    },
    averagePersonalityScore(state) {
      if (state.profiles.length > 0) {
        const userProfile = state.profiles.find(p => p.audience === false);
        const features = userProfile.profile.profile.personality;
        let sum = 0;
        features.forEach((a) => { sum += a.raw_score; });
        return ((sum / features.length) * 10).toFixed(1);
      }
      return 0;
    },
    audienceProfiles(state) {
      if (state.profiles.length > 0) {
        return state.profiles.filter(p => p.audience === true);
        // return profiles.map(p => p.profile.profile.personality);
      }
      return [];
    },
    comparison(state) {
      if (state.profiles.length > 1) {
        const comparison = {
          user: state.profiles.filter(p => p.audience === false)[0].profile.profile.personality,
          audience: state.profiles.filter(p => p.audience === true)[0].profile.profile.personality,
        };
        const dataset = [];
        for (let i = 0; i < comparison.user.length; i += 1) {
          // Multiplying by 10 here, could be done elsewhere
          dataset.push({
            value: [comparison.user[i].raw_score * 10, comparison.audience[i].raw_score * 10],
            name: comparison.user[i].name,
          });
        }
        return dataset;
      }
      return [];
    },
  },
  actions: {
    getVideoProfiles(context) {
      return new Promise((resolve, reject) => {
        ProfilesApi.getVideoProfiles(context.rootGetters['videos/selectedVideo']._id)
          .then((response) => {
            context.commit('SET_PROFILES', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAudienceProfile(context, audienceProfile) {
      return new Promise((resolve, reject) => {
        ProfilesApi.getAudienceProfile({
          text: audienceProfile.text,
          name: audienceProfile.name,
          video_id: context.rootGetters['videos/selectedVideo']._id,
          audience: true,
        })
          .then((response) => {
            context.commit('SET_SELECTED_AUDIENCE_PROFILE', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setSelectedAudienceProfile(context, audienceProfile) {
      context.commit('SET_SELECTED_AUDIENCE_PROFILE', audienceProfile);
    },
    deleteAudienceProfile(context, audienceProfile) {
      ProfilesApi.deleteAudienceProfile(audienceProfile)
        .then(() => {
          if (audienceProfile === context.state.selectedAudienceProfile) {
            context.commit('SET_SELECTED_AUDIENCE_PROFILE', {});
          }
        });
    },
    resetState(context) {
      context.commit('RESET_STATE');
    },
  },
  mutations: {
    SET_PROFILES: (state, profiles) => {
      state.profiles = profiles;
    },
    SET_SELECTED_AUDIENCE_PROFILE: (state, profile) => {
      state.selectedAudienceProfile = profile;
    },
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState());
    },
  },
};
